import { PaletteColor } from '@mui/material';

export type SupportedLocales = 'en-CA' | 'fr-CA';

export interface LanguageDetail {
  key: SupportedLocales,
  title: string,
  description: string
}

export const languageDetails: LanguageDetail[] = [
  { key: 'en-CA', title: 'EN', description: 'English' },
  { key: 'fr-CA', title: 'FR', description: 'Francais' },
];

export interface TenantInfo {
  id: string,
  identifier: string,
  name: string
}

export interface TenantTheme {
  primary?: PaletteColor,
  secondary?: PaletteColor
}